// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DivWrapper } from "@bg/XDL/constants";
import { color, printStyles } from "@bg/XDL/Utilities";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface OnePageCheckoutPageLayoutSharedStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
    leftSection?: InjectableCss;
    title?: TypographyPresentationProps;
    infoSection?: InjectableCss;
    productsContainer?: InjectableCss;
    rightSection?: InjectableCss;
}

const onePageCheckoutPageLayoutSharedStyles: OnePageCheckoutPageLayoutSharedStyles = {
    wrapper: {
        css: css`
            margin-top: 64px; // Header height
        `,
    },
    container: {
        css: css`
            display: grid;
            grid-template-columns: minmax(0, auto) minmax(0, 300px);
            gap: 20px;
            ${xScreen("lte", "lg")} {
                grid-template-columns: minmax(0, auto) minmax(0, 319px);
            }
            ${xScreen("lt", "sm")} {
                grid-template-columns: 1fr;
                gap: 32px;
            }

            @media print {
                display: block;
            }
        `,
    },
    title: {
        variant: "h1",
    },
    leftSection: {
        css: css`
            display: flex;
            flex-direction: column;
            border-top: 2px solid ${color("common.ui3")};

            @media print {
                display: block;
                margin-top: 24px;
            }
        `,
    },
    infoSection: {
        css: css`
            border-bottom: 2px solid ${color("common.ui3")};
            padding: 32px 0;

            &:has(${DivWrapper}:empty) {
                display: none;
            }
            @media print {
                display: block;
                break-inside: avoid;
            }
        `,
    },
    productsContainer: {
        css: css`
            padding-top: 32px;
            ${xScreen("lte", 1200)} {
                padding-top: 0;
            }
            ${xScreen("lt", "sm")} {
                order: 2;
            }
            ${printStyles.avoidBreakInside}
        `,
    },
    rightSection: {
        css: css`
            & > div {
                position: sticky;
                top: 80px;
            }
            ${xScreen("lt", "sm")} {
                order: 3;
            }
        `,
    },
};

export default onePageCheckoutPageLayoutSharedStyles;
